import { PricingPortalAPI } from "../../../apis/pricing-api";
import { handlePostAction } from "../../../utils/event-api-invoke";
import { getPezodeAPIPostSchema, getPezodeAPIDeleteSchema, getPezodeAuditInfoSchema } from "../pezode/create/schema";

let _isError = false;

const _getPreviousState = (data) => {
    try {
        let _prevState = {};

        _prevState.Location = data?.pezodein?.Location?.label || "";
        _prevState.Zone = data?.pezodein?.Zone?.label || "";
        _prevState.PestCode = data?.pezodein?.Pest?.label || "";
        _prevState.Device = data?.pezodein?.Device?.label || "";
        _prevState.InputUnit = data?.pezodein?.InputUnit?.label || "";
        _prevState.ICABSProductCode = data?.pezodein?.iCabsProductCode?.label || "";
        _prevState.ICABSProductDetailCode = data?.pezodein?.iCabsProductDetails?.map(item => item.id).join(", ") || "";
        _prevState.Toxic = data?.pezodein?.Toxic || false;
        _prevState.ServicesInVantage = data?.pezodein?.ServicesInVantage || false;
        _prevState.ImpactPercentage = data?.pezodein?.ImpactPercentage || 99999;
        _prevState.Shock = data?.pezodein?.Shock || false;

        if (data?.pezoderange && data.pezoderange.length > 0) {
            const pezoderange = data.pezoderange;
            _prevState.pezodeRange = pezoderange.map((pezode) => ({
                MinimumInputValue: pezode.MininumInputValue || "",
                MaximumInputValue: pezode.MaximumInputValue || "",
                OutputUnit: pezode.OutputUnit.label || "",
                OutputUnitValue: pezode.OutputUnitValue || "",
                OutputValue: pezode.OutputValue || "",
                Summation: pezode && pezode.Summation ? pezode.Summation : 0,
                Id: pezode.PezodeRangeId || "",
                ...(data?.Deleted && { Action: "DELETE" }),
            }));
        }

        if (data?.consumableproductmap && data.consumableproductmap.length > 0) {
            const consumableproductmap = data.consumableproductmap;
            _prevState.consumableProduct = consumableproductmap.map((pezode) => ({
                ConsumableProduct: pezode.ConsumableProduct.label || "",
                ProductPerDevice: pezode.ProductPerDevice || "",
                Id: pezode.PezodeProductMapId || "",
                ...(data?.Deleted && { Action: "DELETE" }),
            }));
        }


        return JSON.stringify(_prevState);
    } catch (err) {
        _isError = true;
        alert(err);
    }
};

const _getCurrentState = (data) => {
    try {
        let _currentState = {};

        _currentState.Location = data?.pezodein?.Location?.label || "";
        _currentState.Zone = data?.pezodein?.Zone?.label || "";
        _currentState.PestCode = data?.pezodein?.Pest?.label || "";
        _currentState.Device = data?.pezodein?.Device?.label || "";
        _currentState.InputUnit = data?.pezodein?.InputUnit?.label || "";
        _currentState.ICABSProductCode = data?.pezodein?.iCabsProductCode?.label || "";
        _currentState.ICABSProductDetailCode = data?.pezodein?.iCabsProductDetails?.map(item => item.id).join(", ") || "";
        _currentState.Toxic = data?.pezodein?.Toxic || false;
        _currentState.ServicesInVantage = data?.pezodein?.ServicesInVantage || false;
        _currentState.ImpactPercentage = data?.pezodein?.ImpactPercentage || 99999;
        _currentState.Shock = data?.pezodein?.Shock || false;

        if (data?.pezoderange && data.pezoderange.length > 0) {
            const pezoderange = data.pezoderange.filter(pezode => pezode.deleted ? (pezode.PezodeRangeId && pezode.deleted) : true);
            _currentState.pezodeRange = pezoderange.map((pezode) => ({
                MinimumInputValue: pezode.MininumInputValue || "",
                MaximumInputValue: pezode.MaximumInputValue || "",
                OutputUnit: pezode.OutputUnit.label || "",
                OutputUnitValue: pezode.OutputUnitValue || "",
                OutputValue: pezode.OutputValue || "",
                Summation: pezode && pezode.Summation ? pezode.Summation : 0,
                ...(pezode.PezodeRangeId && { Id: pezode.PezodeRangeId }),
                Action: pezode.Deleted ? "DELETE" : pezode.PezodeRangeId ? "EDIT" : "CREATE"
            }));
        }

        if (data?.consumableproductmap && data.consumableproductmap.length > 0) {
            const consumableproductmap = data.consumableproductmap.filter(pezode => pezode.deleted ? (pezode.PezodeProductMapId && pezode.deleted) : true);
            _currentState.consumableProduct = consumableproductmap.map((pezode) => ({
                ConsumableProduct: pezode.ConsumableProduct.label || "",
                ProductPerDevice: pezode.ProductPerDevice || "",
                ...(pezode.PezodeProductMapId && { Id: pezode.PezodeProductMapId }),
                Action: pezode.Deleted ? "DELETE" : pezode.PezodeProductMapId ? "EDIT" : "CREATE"
            }));
        }

        return JSON.stringify(_currentState);
    } catch (err) {
        _isError = true;
        alert(err);
    }
};

const getAuditInfo = (data, auditConfig) => {
    try {
        let _auditSchema = getPezodeAuditInfoSchema();
        let _isDeleted = data?.Deleted;

        _auditSchema.auditInfo[0].shortDesc = data?.pezodein?.Pest?.label + (data?.pezodein?.Zone?.label ? "-" + data?.pezodein?.Zone?.label : "") + "-" + data?.pezodein?.Device?.label;
        _auditSchema.auditInfo[0].currentState = (_isDeleted) ? "{}" : _getCurrentState(data); //If the record is deleted, previousState will be available. The currentState will be available for creation.
        if (auditConfig.editPezodeId) {
            _auditSchema.auditInfo[0].LocationKey = auditConfig.editPezodeId;
            _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
            _auditSchema.auditInfo[0].shortDesc = _isDeleted ?
                _auditSchema.auditInfo[0].shortDesc + (data?.pezodein?.infestationLevel?.label ? "-" + data?.pezodein?.infestationLevel.label : "") :
                _auditSchema.auditInfo[0].shortDesc + (data?.pezodein?.infestationLevel[0]?.label ? "-" + data?.pezodein?.infestationLevel[0].label : "");
            _auditSchema.auditInfo[0].previousState = _getPreviousState(auditConfig.formdata);
        } else {
            _auditSchema.auditInfo[0].Action = "CREATE";
        }

        return _auditSchema;
    } catch (err) {
        _isError = true;
        alert(err);
    }
};

const getPostPayload = (data, config) => {
    try {

        let _isDeleted = data?.Deleted;
        let _postSchema = {};
        if (_isDeleted) {
            _postSchema = getPezodeAPIDeleteSchema(config.countryCode, config.businessCode);

            _postSchema.pezodein[0].PezodeId = config.editPezodeId;
            _postSchema.pezodein[0].Id = config.editPezodeId;
            _postSchema.pezodein[0].Deleted = _isDeleted;

        } else {
            _postSchema = getPezodeAPIPostSchema(config.countryCode, config.businessCode);

            _postSchema.pezodein[0].LocationId = data?.pezodein?.Location?.id || "";
            _postSchema.pezodein[0].ZoneLocationId = data?.pezodein?.Zone?.id || "";
            _postSchema.pezodein[0].ICABSPestCode = data?.pezodein?.Pest?.id || "";
            _postSchema.pezodein[0].PestCode = data?.pezodein?.Pest?.id || "";
            _postSchema.pezodein[0].DeviceId = data?.pezodein?.Device?.id || "";
            _postSchema.pezodein[0].InputUnit = data?.pezodein?.InputUnit?.id || "";
            _postSchema.pezodein[0].ICABSProductCode = data?.pezodein?.iCabsProductCode?.id || "";
            _postSchema.pezodein[0].ICABSProductDetailCode = data?.pezodein?.iCabsProductDetails?.map(item => item.id).join(",") || "";
            let _addedInfestationLevels = data?.pezodein?.infestationLevel || "";
            for (let i = 0; i < _addedInfestationLevels.length; i++) {
                _postSchema.pezodein[0].infestationLevelId.push(_addedInfestationLevels[i].id);
            }
            _postSchema.pezodein[0].Toxic = data?.pezodein?.Toxic || false;
            _postSchema.pezodein[0].ServicesInVantage = data?.pezodein?.ServicesInVantage || false;
            _postSchema.pezodein[0].ImpactPercentage = data?.pezodein?.ImpactPercentage || 99999;
            _postSchema.pezodein[0].Shock = data?.pezodein?.Shock || false;

            if (config.editPezodeId) {
                _postSchema.pezodein[0].PezodeId = config.editPezodeId;
                _postSchema.pezodein[0].Id = config.editPezodeId;
            }

            if (data?.pezoderange && data.pezoderange.length > 0) {
                const pezodes = data.pezoderange.filter(pezode => pezode.deleted ? (pezode.PezodeRangeId && pezode.deleted) : true);
                _postSchema.pezodein[0].pezoderange = pezodes.map((pezode) => ({
                    Formula: "($dimension/$outputValue)*$outputUnit + $summation",
                    MinimumInputValue: pezode.MininumInputValue || "",
                    MaximumInputValue: pezode.MaximumInputValue || "",
                    OutputUnit: pezode.OutputUnit.id || "",
                    OutputUnitValue: pezode.OutputUnitValue || "",
                    OutputValue: pezode.OutputValue || "",
                    Summation: pezode && pezode.Summation ? pezode.Summation : 0,
                    PezodeRangeId: pezode.PezodeRangeId || "",
                    Deleted: pezode.Deleted || false
                }));
            }

            if (data?.consumableproductmap && data.consumableproductmap.length > 0) {
                const consumableproductmap = data.consumableproductmap.filter(pezode => pezode.deleted ? (pezode.PezodeProductMapId && pezode.deleted) : true);
                _postSchema.pezodein[0].consumableproductmap = consumableproductmap.map((pezode) => ({
                    ConsumableProductId: pezode.ConsumableProduct.id || "",
                    ProductPerDevice: pezode.ProductPerDevice || "",
                    PezodeProductMapId: pezode.PezodeProductMapId || "",
                    Deleted: pezode.Deleted || false,
                }));
            }
        }

        return _postSchema;
    } catch (err) {
        _isError = true;
        alert(err);
    }
};

const getPezodeRange = async (EditPezodeId, settingsConfig) => {
    let response = await PricingPortalAPI.getFilterList(
        settingsConfig.businessCode,
        settingsConfig.countryCode,
        "getPezodeRangeList",
        "pezoderange",
        `&pezodeid=${EditPezodeId}`
    );
    return response;
};

const getPezodeProductMap = async (EditPezodeId, settingsConfig) => {
    let response = await PricingPortalAPI.getFilterList(
        settingsConfig.businessCode,
        settingsConfig.countryCode,
        "getPezodeProductMap",
        "pezodeproductmap",
        `&pezodeid=${EditPezodeId}`
    );
    return response;
};

const savePezode = async (data, uihandler) => {
    let status = {
        responseStatus: null,
        error: null,
    };
    const {
        editPezodeId,
        settingsConfig: { businessCode, countryCode },
        formdata
    } = uihandler;
    try {
        let _auditInfo = getAuditInfo(data, { editPezodeId, formdata });
        let _postPayload = getPostPayload(data, { editPezodeId, businessCode, countryCode });

        let _postRequest = { ..._postPayload, ..._auditInfo };

        let res = await handlePostAction(_postRequest, "pezode");
        if (res && res.status && res.status === 200) {
            if (res.data.errorNumber > 0) {
                _isError = true;
                status.errorMessage = res.data.errorDescription;
            } else {
                status.responseStatus = res.status;
            }
        }

    } catch (err) {
        _isError = true;
        alert(err);
    } finally {
        return { ...status, error: _isError };
    }
};

export { savePezode, getPezodeRange, getPezodeProductMap };
